import { PostMedia } from './PostMedia'

export default PostMedia
